import type { ReactElement } from 'react';
import { QueryClient, QueryClientProvider, QueryFunction, QueryKey } from '@tanstack/react-query';
import { apiClient } from 'Shared/api_client';

/**
 * This default query function allows us to use the `useQuery` hook with only the API route
 * Example:
 *    const { data, isLoading, error } = useQuery({ queryKey: ['guides/123']});
 */
const defaultQueryFn: QueryFunction<unknown, QueryKey> = async ({ queryKey }) => {
   const endpoint = queryKey[0];
   const response = await apiClient.get('' + endpoint);
   return response.data;
};

const queryClient = new QueryClient({
   defaultOptions: {
      queries: {
         queryFn: defaultQueryFn,
      },
   },
});

export function initializeReactQuery(component: ReactElement): ReactElement {
   return <QueryClientProvider client={queryClient}>{component}</QueryClientProvider>;
}
